"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ParameterBase_1 = require("./ParameterBase");
const MultiplicityType_1 = require("./MultiplicityType");
class SingleValueParameter extends ParameterBase_1.ParameterBase {
    constructor(id, type, allowNullable, initialValue, handleChange) {
        super(id, type, allowNullable, handleChange);
        this.value = initialValue;
    }
    get multiplicityType() {
        return MultiplicityType_1.MultiplicityType.Single;
    }
    get value() {
        return this._value;
    }
    set value(val) {
        if (!this.allowNullable && val === undefined) {
            throw `Cannot assign null to non-nullable parameter ${this.id}`;
        }
        const isValueNull = this.allowNullable && val === undefined;
        if (!isValueNull) {
            const isValueValid = !Array.isArray(val) && this._isValueValid(val);
            if (!isValueValid) {
                throw `Invald value type from parameter ${this.id}`;
            }
        }
        this._value = val;
        // raise property changed
        this._onPropertyChange(this.id, this.value);
    }
}
exports.SingleValueParameter = SingleValueParameter;
//# sourceMappingURL=SingleValueParameter.js.map